import { SpaceBetween } from "@cloudscape-design/components-themed";
import SearchBar from "../components/individual-counseling-project/SearchBar";
import Table from "../components/individual-counseling-project/Table";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

const IndividualCounselingProject = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);

  return (
    <SpaceBetween size="l">
      <SearchBar />
      <Table />
    </SpaceBetween>
  );
};

export default IndividualCounselingProject;
